import e from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: a = 16, useVw: n, useRem: l, color: c, withColor: o, removeClassName: t, disableSSR: m, style: r, ...p }) => {
  const f = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ e.createElement(g, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-mingwenfahang", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: f, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-é­æåè¡"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? i(c, 0, "#262933") : "#262933",
        datafollowfill: o ? i(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M4.9 16C4.9 10.422 9.422 5.9 15 5.9c5.578 0 10.1 4.522 10.1 10.1a.9.9 0 0 0 1.8 0c0-6.572-5.328-11.9-11.9-11.9S3.1 9.428 3.1 16 8.428 27.9 15 27.9a.9.9 0 0 0 0-1.8C9.422 26.1 4.9 21.578 4.9 16Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M13.284 12.464a4.323 4.323 0 0 1 4.21 1 4.323 4.323 0 0 1 1.24 4.144.9.9 0 0 0 1.751.414 6.123 6.123 0 0 0-1.756-5.868 6.123 6.123 0 0 0-5.959-1.415.9.9 0 1 0 .514 1.725Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M16.48 14.38a.9.9 0 0 1 .056 1.271l-4.47 4.877a.9.9 0 1 1-1.327-1.217l4.47-4.876a.9.9 0 0 1 1.272-.056Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M27.402 20.325c.357-1.073-.801-2.018-1.78-1.453l-7.197 4.159c-.918.53-.78 1.894.226 2.23l2.5.833 1.77 1.915a1.229 1.229 0 0 0 2.067-.444l2.414-7.24Zm-7.462 3.678 5.634-3.255-1.905 5.714-1.481-1.605a.799.799 0 0 0-.335-.216l-1.913-.638Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, w = x;
export {
  w as default
};
